<template>
  <b-modal id="view_service_report_modal" ref="view_service_report_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="far fa-file"></i> Service Check Report</h1>

        <p id="mh-info" v-if="notEmptyObject(file_uploaded_by)">
          Uploaded by
          <span>{{ file_uploaded_by.first_name }} {{ file_uploaded_by.surname }}</span>
          on {{ file_uploaded_date | formatDate }}
        </p>

      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div id="image_container">
      <img v-if="file_type === 'jpg' || file_type === 'JPG' || file_type === 'png' || file_type === 'PNG' || file_type === 'jpeg' || file_type === 'JPEG' || file_type === 'gif' ||
  file_type === 'GIF' || file_type === 'bmp' || file_type === 'BMP'" :src="file_path" style="max-width: 100%; display: block;" alt="uploaded file"/>

      <div v-if="file_type === 'pdf' || file_type === 'PDF' ">
        <object :data="file_path" type="application/pdf" style="width: 100%; min-height: 600px;">
          alt : <a :href="file_path">{{ file_name }}</a>
        </object>
      </div>
    </div>

  </b-modal>
</template>

<script>

export default {
  name: "view_service_report_file",
  data() {
    return {
      crm_url: process.env.MIX_APP_URL,
      temp_file_path: this.$store.state.files.service_report_file.file_path,
      file_uploaded_by: this.$store.state.files.service_report_file.uploaded_by,
      file_uploaded_date: this.$store.state.files.service_report_file.uploaded_date
    }
  },
  computed: {
    file_path() {
      return this.crm_url + '/' + this.temp_file_path.replace(/^public/gi, 'storage')
    },
    file_type() {
      return /[^.]*$/.exec(this.file_path)[0];
    },
    file_name() {
      return /[^\/]*$/.exec(this.file_path)[0];
    }
  },
  methods: {
    hideModal() {
      this.$refs.view_service_report_modal.hide();
      this.$store.commit('HIDE_SERVICE_REPORT_MODAL');
    },
  }
}
</script>

<style lang="scss" scoped>
#image_container {
  width: 100%;
}
</style>
